<template>
  <v-layout row class="align-center layout app--page-header" style="margin-top:-15px; margin-left:0px; margin-bottom:-5px;">
    <div class="page-header-left">
      <h3 class="title">{{title}}</h3>
    </div>  
    <v-spacer></v-spacer>     
    <a style="text-decoration:none" href="#/" class="mr-2"><v-icon small>home</v-icon></a>
    <div class="mr-2">
        <v-breadcrumbs :items="breadcrumbs" style="pa-0">
        <template v-slot:divider>
            <v-icon>keyboard_arrow_right</v-icon>
        </template>
        </v-breadcrumbs>
    </div>
  </v-layout>  
</template>
<script>
export default {
    data : ()=>({
        title: ''        
    }),
    computed: {
        breadcrumbs: function () {
            let breadcrumbs = [];            
            let route = this.$route.name.split('/');
            let link  = '#';
            let name  = '';
            let path  = '';           
            //this.title = this.$route.title;

            
            this.setTitle('Home');
            route.forEach((value, i) => {                 
                link += '/'+value;                
                path += '/'+value;                              
                name += i==0?value:'/'+value;                              

                var disabled = true;
                this.$router.options.routes.forEach(route => {
                    if(Array.isArray(route.children)){
                        route.children.forEach(croute => {      
                            if(path === '/'+croute.path){
                                disabled = false;
                                this.setTitle(croute.title || value.capitalize());
                            }  
                        })
                    }                                        
                    if(path === '/'+route.path){
                        disabled = false;
                        this.setTitle(route.title || route.name);
                    }                    
                });  

                let query = '';
                if(this.$route.query){
                    let ke = 0;                    
                    for(var j in this.$route.query){
                        if(ke == 0){
                            query += '?';
                        } else {
                            query += '&';                            
                        }
                        query += j+'='+this.$route.query[j];
                        ke++;
                    }
                }

                breadcrumbs.push({
                    text: value,     
                    href: link + query,         
                    //to: {name:name},
                    disabled: disabled
                });                   
            });      
            return breadcrumbs;
        }    
    },
    methods:{
        refresh(){
            location.reload();
        },
        setTitle(title){
            this.title = title; 
        }
    }
    
};
</script>
<style>
.v-breadcrumbs li:nth-child(even) {
    padding: 0px 0px !important;
}
.v-application ul, .v-application ol {
    padding-left : 0px;
    padding-right: 0px;
}
</style>
